import React from 'react';
const SvgVsdx = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg viewBox="0 0 48 48" width="1em" height="1em" {...props}>
      <path fill="#FFF" d="M43 44H13V4h21l9 9z" />
      <path fill="#949494" d="M34 3H12v42h32V13L34 3zm0 1.5l8.5 8.5H34V4.5zM43 44H13V4h20v10h10v30z" />
      <path fill="#C8C8C8" d="M26 27v5h-5v-5h5m1-1h-7v7h7v-7z" />
      <path fill="#3955A3" d="M4 17l20-3v26L4 37z" />
      <path
        fill="#C8C8C8"
        d="M36.5 34c1.378 0 2.5 1.122 2.5 2.5S37.878 39 36.5 39 34 37.878 34 36.5s1.122-2.5 2.5-2.5m0-1a3.5 3.5 0 100 7 3.5 3.5 0 000-7zM31.5 18c1.378 0 2.5 1.122 2.5 2.5S32.878 23 31.5 23 29 21.878 29 20.5s1.122-2.5 2.5-2.5m0-1a3.5 3.5 0 100 7 3.5 3.5 0 000-7zM37 29H27v1h10v-1z"
      />
      <path
        fill="#C8C8C8"
        d="M37 29h-1v5h1v-5zM32 23h-1v7h1v-7zM16.5 7a.5.5 0 100 1 .5.5 0 000-1zM19.5 7a.5.5 0 100 1 .5.5 0 000-1zM19.5 10a.5.5 0 100 1 .5.5 0 000-1zM22.5 7a.5.5 0 100 1 .5.5 0 000-1zM25.5 7a.5.5 0 100 1 .5.5 0 000-1zM28.5 7a.5.5 0 100 1 .5.5 0 000-1zM39.5 18a.5.5 0 100 1 .5.5 0 000-1zM39.5 21a.5.5 0 100 1 .5.5 0 000-1zM39.5 24a.5.5 0 100 1 .5.5 0 000-1zM39.5 27a.5.5 0 100 1 .5.5 0 000-1zM39.5 30a.5.5 0 100 1 .5.5 0 000-1zM30.5 39a.5.5 0 100 1 .5.5 0 000-1zM27.5 39a.5.5 0 100 1 .5.5 0 000-1z"
      />
      <path
        fill="#FFF"
        d="M19 21l-3.665 12H12.62L9 21h2.582l2.218 8.351c.118.452.19.851.215 1.197h.044c.035-.373.112-.783.23-1.23L16.493 21H19z"
      />
      <linearGradient id="vsdx_svg__a" gradientUnits="userSpaceOnUse" x1={8.587} y1={5.864} x2={42.489} y2={46.268}>
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.226} stopColor="#fcfcfc" stopOpacity={0.023} />
        <stop offset={0.363} stopColor="#f4f4f4" stopOpacity={0.036} />
        <stop offset={0.475} stopColor="#e6e6e6" stopOpacity={0.048} />
        <stop offset={0.574} stopColor="#d1d1d1" stopOpacity={0.057} />
        <stop offset={0.665} stopColor="#b7b7b7" stopOpacity={0.067} />
        <stop offset={0.75} stopColor="#979797" stopOpacity={0.075} />
        <stop offset={0.83} stopColor="#707070" stopOpacity={0.083} />
        <stop offset={0.906} stopColor="#444" stopOpacity={0.091} />
        <stop offset={0.976} stopColor="#121212" stopOpacity={0.098} />
        <stop offset={1} stopOpacity={0.1} />
      </linearGradient>
      <path fill="url(#vsdx_svg__a)" d="M44 13L34 3H12v42h32V13z" />
      <linearGradient id="vsdx_svg__b" gradientUnits="userSpaceOnUse" x1={38} y1={16.906} x2={38} y2={14.088}>
        <stop offset={0} stopColor="#828282" stopOpacity={0} />
        <stop offset={0.281} stopColor="#7f7f7f" stopOpacity={0.028} />
        <stop offset={0.45} stopColor="#777" stopOpacity={0.045} />
        <stop offset={0.59} stopColor="#696969" stopOpacity={0.059} />
        <stop offset={0.713} stopColor="#545454" stopOpacity={0.071} />
        <stop offset={0.826} stopColor="#3a3a3a" stopOpacity={0.083} />
        <stop offset={0.929} stopColor="#1a1a1a" stopOpacity={0.093} />
        <stop offset={1} stopOpacity={0.1} />
      </linearGradient>
      <path fill="url(#vsdx_svg__b)" d="M33 14h10v3H33z" />
      <linearGradient id="vsdx_svg__c" gradientUnits="userSpaceOnUse" x1={31.27} y1={12.23} x2={37.236} y2={6.264}>
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.854} stopColor="#fff" stopOpacity={0.213} />
        <stop offset={1} stopColor="#fff" stopOpacity={0.25} />
      </linearGradient>
      <path fill="url(#vsdx_svg__c)" d="M12 3v1h21v10h10v14h1V13L34 3z" />
      <linearGradient id="vsdx_svg__d" gradientUnits="userSpaceOnUse" x1={17.754} y1={42.918} x2={18.177} y2={38.93}>
        <stop offset={0} stopColor="#828282" stopOpacity={0} />
        <stop offset={0.17} stopColor="#7e7e7e" stopOpacity={0.034} />
        <stop offset={0.346} stopColor="#717171" stopOpacity={0.069} />
        <stop offset={0.525} stopColor="#5d5d5d" stopOpacity={0.105} />
        <stop offset={0.706} stopColor="#404040" stopOpacity={0.141} />
        <stop offset={0.886} stopColor="#1b1b1b" stopOpacity={0.178} />
        <stop offset={0.997} stopOpacity={0.2} />
      </linearGradient>
      <path fill="url(#vsdx_svg__d)" d="M24 43H12v-4.8L24 40z" />
      <linearGradient id="vsdx_svg__e" gradientUnits="userSpaceOnUse" x1={14} y1={39.188} x2={14} y2={14.758}>
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.859} stopColor="#fff" stopOpacity={0.155} />
        <stop offset={1} stopColor="#fff" stopOpacity={0.18} />
      </linearGradient>
      <path fill="url(#vsdx_svg__e)" d="M24 14L4 17v20l20 3z" />
    </svg>
  );
});
export default SvgVsdx;
SvgVsdx.iconName = 'vsdx';
SvgVsdx.displayName = 'SvgVsdx';
